// extracted by mini-css-extract-plugin
export default {"dialog":"dialog-2TChfX"};